import { UserAdminRole } from "oneclick-component/src/store/apis/enhancedApi";

export const ALL_ADMIN_ROLES: Readonly<UserAdminRole[]> = [
  "ADMIN",
  "MANAGER",
  "LANDLORD",
] as const;
